import React, { useEffect } from 'react';
import { useParams, Navigate, Link } from 'react-router-dom';
import { BLOG_POSTS } from '../data/blogData';
import SEO from '../components/SEO';
import './Blog.css';

function BlogPost() {
  const { slug } = useParams();
  const post = BLOG_POSTS.find(p => p.slug === slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!post) {
    return <Navigate to="/blog" replace />;
  }

  return (
    <div className="blog-post-page">
      <SEO 
        title={post.title}
        description={post.excerpt}
        url={`/blog/${slug}`}
        breadcrumbs={[
          { name: 'Home', url: '/' },
          { name: 'Blog', url: '/blog' },
          { name: post.title, url: `/blog/${slug}` }
        ]}
      />

      <article className="blog-article">
        <div className="container">
          <Link to="/blog" className="back-link">← Back to Blog</Link>
          
          <header className="article-header">
            <h1>{post.title}</h1>
            <div className="article-meta">
              <span>By {post.author}</span>
              <span>•</span>
              <span>{post.date}</span>
            </div>
            <img src={post.image} alt={post.title} className="article-hero-image" />
          </header>

          <div className="article-content">
            {post.content.map((block, index) => {
              switch (block.type) {
                case 'heading':
                  return <h2 key={index}>{block.text}</h2>;
                case 'subheading':
                  return <h3 key={index}>{block.text}</h3>;
                case 'paragraph':
                  return <p key={index}>{block.text}</p>;
                case 'image':
                  return (
                    <figure key={index} className="article-image">
                      <img src={block.url} alt={block.alt} />
                      {block.caption && <figcaption>{block.caption}</figcaption>}
                    </figure>
                  );
                default:
                  return null;
              }
            })}
          </div>
        </div>
      </article>
    </div>
  );
}

export default BlogPost;
